import {RouteDefinition} from '../../../../routes';
import {GatewayControlScreen} from './GatewayControlScreen';

export const GatewayControlRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/gateway-control/:id',
        component: GatewayControlScreen,
    },
];
